import React from 'react'
import { parseLocalizedNumber } from '../../../services/functions';

const RemainingTS = ({remain}) => {
  let printRemain =parseLocalizedNumber(remain);
  return (
    <div className="d-flex flex-row bd-highlight">
        {printRemain < 0 ? (
          <div
          className="p-2 bd-highlight"
          style={{ fontSize: "13px", fontFamily: "yekan" }}
        >
            <span>به تعویق افتاده</span>
        </div>
      ) : (
        <>
            <div
              className="p-2 bd-highlight"
              style={{ fontSize: "13px", fontFamily: "yekan" }}>
              {remain}
            </div>
            <div className="p-2 bd-highlight" style={{ fontSize: "14px" }}>
              روز مانده
            </div>
        </>
      )}
  </div>
  )
}

export default RemainingTS